<template>
    <svg
      enable-background="new 0 0 32 32"
      :height="width"
      viewBox="0 0 32 32"
      :width="width"
      :fill="svgColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Layer_10">
        <path
          d="m24.97 1.1h-11.44c-.893 0-1.725.348-2.336.973l-6.507 6.498c-.617.63-.957 1.461-.957 2.339l-.01 16.68c0 1.825 1.485 3.31 3.311 3.31h17.931c1.824 0 3.309-1.484 3.311-3.309l.007-23.181c0-1.825-1.485-3.31-3.31-3.31zm-13.334 3.076v3.324c0 .833-.677 1.51-1.51 1.51h-3.332zm14.835 23.414c0 .833-.678 1.51-1.51 1.51h-17.931c-.833 0-1.51-.678-1.51-1.51l.01-16.68c0-.034.008-.067.01-.101h4.586c1.825 0 3.311-1.484 3.311-3.31v-4.59c.031-.002.061-.009.093-.009h11.44c.833 0 1.51.678 1.51 1.51z"
        />
        <path
          d="m23.376 13.6h-14.75c-.497 0-.9.403-.9.9s.403.9.9.9h14.75c.497 0 .9-.403.9-.9s-.403-.9-.9-.9z"
        />
        <path
          d="m23.376 8.433h-7.111c-.497 0-.9.403-.9.9s.403.9.9.9h7.111c.497 0 .9-.403.9-.9s-.403-.9-.9-.9z"
        />
        <path
          d="m8.622 20.572h5.479c.497 0 .9-.403.9-.9s-.403-.9-.9-.9h-5.479c-.497 0-.9.403-.9.9s.403.9.9.9z"
        />
        <path
          d="m14.361 23.924h-5.739c-.497 0-.9.403-.9.9s.403.9.9.9h5.739c.497 0 .9-.403.9-.9s-.403-.9-.9-.9z"
        />
        <path
          d="m20.369 21.373c-1.384-.315-1.513-.66-1.504-.792.05-.727 1.405-.886 2.258-.854 0 .497.403.9.9.9s.9-.403.9-.9c0-.501-.207-.989-.568-1.337-.348-.337-.803-.517-1.284-.514v-.246c0-.497-.403-.9-.9-.9s-.9.403-.9.9v.491c-1.765.498-2.151 1.614-2.201 2.337-.088 1.313.888 2.21 2.899 2.669 1.128.257 1.521.583 1.517.785-.021.785-1.771.9-2.229.9-.009 0-.018 0-.026 0-.016-.016-.016-.033-.016-.04 0-.497-.403-.9-.9-.9s-.9.403-.9.9c0 .508.201.981.566 1.333.344.333.812.52 1.29.522v.24c0 .497.403.9.9.9s.9-.403.9-.9v-.489c1.917-.541 2.197-1.81 2.213-2.421.032-1.266-.948-2.136-2.915-2.584z"
        />
      </g>
    </svg>
  </template>
  
  <script>
  export default {
    props: {
      svgColor: {
        type: String,
        default: "#000000", // Set a default fill color if not provided
      },
    },
  };
  </script>
  